import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { ANALYTICS_DIALOGS, DOWNLOAD_REPORT_CLOSED, DOWNLOAD_REPORT_FINISHED } from '../../../constants/analytics';
import { SET_DOWNLOAD_REPORT_STATUS, SET_DIALOG } from '../../../store/reducers/analytics';

import { alertSuccess } from '../../../store/actions/alert';
import { AnalyticsSpinner } from '../../common/Spinner/AnalyticsSpinner';
import RadioGroup from '../../common/RadioGroup/RadioGroup';
import Radio from '../../common/Radio';

import styles from './ExportReportOptionsModal.module.scss';

export function ExportReportOptionsModal({ onExport, onClose }) {
  const dispatch = useDispatch();
  const {
    ui: {
      loading: { exportModal: isLoading },
      downloadReportStatus,
    },
  } = useSelector((state) => state.analytics);

  const [onlySelectedColumns, setOnlySelectedColumns] = useState(true);

  useEffect(() => {
    if (downloadReportStatus === DOWNLOAD_REPORT_FINISHED || downloadReportStatus === DOWNLOAD_REPORT_CLOSED) {
      dispatch({ type: SET_DOWNLOAD_REPORT_STATUS, payload: { status: null } });
      if (downloadReportStatus === DOWNLOAD_REPORT_FINISHED) {
        dispatch({ type: SET_DIALOG, payload: { dialogId: ANALYTICS_DIALOGS.SEND_REPORT_NOTIFICATION, isOpen: true } });
      } else {
        dispatch(alertSuccess('Report export was downloaded successfully.'));
      }
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadReportStatus]);

  const onSubmit = () => {
    onExport({ onlySelectedColumns });
  };

  return (
    <div className={styles.wrapper}>
      {isLoading ? (
        <AnalyticsSpinner />
      ) : (
        <>
          <fieldset>
            <legend>Export only selected columns?</legend>
            <RadioGroup
              row
              name="filters"
              selectedvalue={onlySelectedColumns ? 'yes' : 'no'}
              onChange={(value) => setOnlySelectedColumns(value === 'yes')}
            >
              <Radio id="yes" value="yes" label="Yes" />
              <Radio id="no" value="no" label="No, export all data" />
            </RadioGroup>
          </fieldset>

          <footer>
            <button type="button" className={styles.button} onClick={onClose}>
              Cancel
            </button>

            <button type="button" className={styles.button} onClick={onSubmit}>
              Export
            </button>
          </footer>
        </>
      )}
    </div>
  );
}

ExportReportOptionsModal.propTypes = {
  onExport: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
